import React, { Component, Fragment } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import playSvg from 'images/video_play.png';

class HowItWorks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    return (
      <Fragment>
        <Modal
          className="works-modal"
          isOpen={this.state.modal}
          toggle={this.toggle}>
          <iframe
            src="https://player.vimeo.com/video/321122099"
            className="play-modal-video"
            frameBorder="0"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allowFullScreen
            title="intro"
          />
          <div className="play-close" onClick={this.toggle}>
            <div className="close-icon" />
          </div>
        </Modal>
        <div className="works" id="how-it-works" id="how_it_works_section">
          <div className="works__content">
            <div className="works__inner">
              <div className="works__title">How it works?</div>
              <div className="works__text">
                Have a look at our demo video for more information
              </div>
              <div className="works__bottom">
                <div className="works-btn__icon" onClick={this.toggle}>
                  <img src={playSvg} alt="acc" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default HowItWorks;



// WEBPACK FOOTER //
// ./src/components/HowItWorks/HowItWorks.js